import React from "react";
import { useTheme } from "../../contexts/ThemeContext";
import { readableColor, darken } from "polished";

export const ProgressKpiCard = ({ label, value, icon, color = "#F4E8FF" }) => {
  const theme = useTheme();
  const contrastColor = readableColor(theme.mode === "dark" ? darken(0.01, color) : color);

  return (
    <article
      className="flex items-center gap-4 p-[20px] rounded-lg shadow-xl flex-1 min-w-[200px]"
      style={{
        backgroundColor: theme.mode === "dark" ? darken(0.2, color) : color,
      }}
    >
      {icon && (
        <div
          className="flex items-center justify-center size-14 rounded-full"
          style={{
            backgroundColor: theme.mode === "dark" ? darken(0.3, color) : darken(0.1, color),
            color: contrastColor,
          }}
        >
          {icon}
        </div>
      )}
      <div>
        <p className="text-5xl font-bold leading-none" style={{ color: contrastColor }}>
          {value}
        </p>
        <p className="text-lg font-medium mt-1" style={{ color: contrastColor }}>
          {label}
        </p>
      </div>
    </article>
  );
};

export default ProgressKpiCard;
